// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"hw","heroImageWrapper":"hx","gradientLeft":"hy","gradientBottom":"hz","brandLogo":"hA"};